export const state = {
  reporting: [
    {
      Stage: "DRAFT",
      Value: 0,
      name: "ຮ່າງໃບຄໍາຮ້ອງ",
      icon: "mdi-file",
      color: "grey",
    },
    {
      Stage: "PENDING",
      Value: 0,
      name: "ລໍຖ້າການຮັບ",
      icon: "mdi-lan-pending",
      color: "blue",
    },
    {
      Stage: "PROCESSING",
      Value: 0,
      name: "ກໍາລັງດໍາເນີນການ",
      icon: "mdi-lan-pending",
      color: "blue",
    },
    {
      Stage: "REJECT",
      Value: 0,
      name: "ຕີກັບ",
      icon: "mdi-comment-alert",
      color: "yellow",
    },
    {
      Stage: "DENY",
      Value: 0,
      name: "ຖືກປະຕິເສດ",
      icon: "mdi-close-octagon",
      color: "red",
    },
    {
      Stage: "APPROVED",
      Value: 0,
      name: "ອະນຸມັດແລ້ວ",
      icon: "mdi-check-circle-outline",
      color: "green",
    },
    {
      Stage: "ALL",
      Value: 0,
      name: "ທັງໝົດ",
      icon: "mdi-view-dashboard-outline",
      color: "white",
    },
    
  ],
  graph: [],
};
